export enum UserType {
  CASTING = 'casting',
  STAFF = 'staff',
  CONTACT = 'contact',
  STAFF_AGENCY = 'staff-agency',
  GUARDIAN = 'guardian',
  TALENT = 'talent',
}
